import DateTimeDisplay from '../../components/DateTimeDisplay'
import EntityListTemplate from '../../templates/EntityListTemplate'
import { getGridStringOperators } from '@mui/x-data-grid'

const AnalysesPage = () => {
  const filtersOperators = getGridStringOperators().filter(
    (operator) =>
      operator.value === 'contains' ||
      operator.value === 'equals' ||
      operator.value === 'startsWith',
  )
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      type: 'string',
      minWidth: 300,
      flex: 2,
      filterable: true,
      sortable: true,
      filterOperators: filtersOperators,
    },
    {
      field: 'description',
      headerName: 'Description',
      type: 'string',
      disableColumnMenu: true,
      sortable: false,
      minWidth: 300,
      flex: 2,
    },
    {
      field: 'gpu_required',
      headerName: 'Needs GPU',
      type: 'boolean',
      disableColumnMenu: false,
      sortable: true,
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'input_group_unit',
      headerName: 'Input Group',
      type: 'string',
      flex: 1,
      filterable: true,
      filterOperators: filtersOperators,
    },
    {
      field: 'output_group_unit',
      headerName: 'Output Group',
      type: 'string',
      flex: 1,
      filterable: true,
      filterOperators: filtersOperators,
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      type: 'string',
      sortable: true,
      filterable: false,
      width: 200,
      flex: 1,
      renderCell: (row) => {
        if (row?.value) {
          return <DateTimeDisplay date={new Date(row.value)} showTime={true} />
        }
      },
    },
  ]

  return (
    <EntityListTemplate
      entityName="analyses"
      columns={columns}
      title="Analyses"
      defaultSort={[{ field: 'createdAt', sort: 'desc' }]}
      defaultFilters={{ items: [] }}
    />
  )
}

export default AnalysesPage
